"use strict";

const RoutineMaintenanceFormGeneral = function () {
  var toggleInspectConditionFields = null;

  var setToggleInspectConditionFields = function (toggleFn) {
    toggleInspectConditionFields = toggleFn;
  };

  var loadListenersWqMonitoringWorkflow = function ($page, data, Controller = null) {
    $page.on("2N:FormInput", `[name="inspection-type"]`, (e, inspectionType) =>
      toggleInspectionType($page, inspectionType),
    );
    toggleInspectionType($page, data.inspectionType);

    if (Controller) {
      $page.on("2N:FormInput", "[name='date'], [name='last-precipitation-date']", () =>
        updateDaysSinceLastRainfall($page, Controller),
      );
      updateDaysSinceLastRainfall($page, Controller);
    }
  };

  var unloadListeners = function ($page) {
    $page.off("2N:FormInput", `[name="inspection-type"]`);
    $page.off(
      "2N:FormInput",
      "[name='date'], [name='last-precipitation-date']",
      updateDaysSinceLastRainfall,
    );
  };

  var toggleInspectionType = function ($element, inspectionType) {
    const $modal = $element.closest(".modal-content");
    const showMeasurementSampleTabs =
      inspectionType === "wq-monitoring" ||
      WqMonitoringConstants.isDryWeatherScreeningType(inspectionType);
    TabbedModal.toggleTab("measurements", showMeasurementSampleTabs);
    TabbedModal.toggleTab("sample", showMeasurementSampleTabs);

    const showIllicitDischarge = WqMonitoringConstants.isDryWeatherScreeningType(inspectionType);
    TabbedModal.toggleTab("illicit-discharge", showIllicitDischarge);
    $modal.find(".inspection-type-show-when-idde-screening").toggle(showIllicitDischarge);

    const $inspectToggle = $modal.find(`[name="inspect-structural-condition-maintenance"]`);
    if (!$inspectToggle.length) {
      return;
    }

    if (inspectionType === "routine-inspection") {
      $inspectToggle.filter(`[value="true"]`).prop("checked", true).trigger("input");
      $inspectToggle.prop("disabled", true);
    } else {
      $inspectToggle.prop("disabled", false);
    }
  };

  var toggleAssetAccessible = function ($element, setIsAccessible = null) {
    const $modal = $element.closest(".modal-content");
    let isAccessible = setIsAccessible;

    if (isAccessible === null) {
      isAccessible = $modal.find(`[name="asset-accessible"]:checked`).val() === "true";
    } else {
      $modal.find(`[name="asset-accessible"][value="${isAccessible}"]`).prop("checked", true);
    }

    _toggleAssetAccessibleSections($modal, isAccessible);
  };

  var _toggleAssetAccessibleSections = function ($modal, isAccessible) {
    const hasCheckedNewIssues = $modal.find(`[name$="[issue]"][value="true"]:checked`).length > 0;
    const hasNoAccessIssue = $modal.find(`[data-issue-key="asset-accessible"]`).length > 0;

    $modal
      .find(`[name="asset-accessible"]`)
      .prop("disabled", hasCheckedNewIssues || hasNoAccessIssue);
    $modal.find(`[data-issue-key="asset-accessible"]`).prop("disabled", hasCheckedNewIssues);

    if (hasNoAccessIssue) {
      $modal.find(`[name="access-issue"]`).prop("disabled", true);
    }

    $modal.find(`.asset-accessible-hide-when-accessible`).toggle(!isAccessible);

    if ($modal.find(`.show-when-accessible-and-inspect`).length > 0) {
      toggleInspectConditionFields?.(isAccessible);
    } else {
      $modal.find(`.asset-accessible-show-when-accessible`).toggle(isAccessible);
    }
  };

  var getTabName = function () {
    return "General Info";
  };

  var updateDaysSinceLastRainfall = function ($page, Controller) {
    const date = Controller.getInspectionRenderData().date;
    const lastRainfallDate = Controller.getInspectionRenderData().lastPrecipitationDate;

    const daysSinceLastRainfall = getDaysSinceLastRainfall(date, lastRainfallDate);

    $page.find(".days-since-last-rainfall").text(daysSinceLastRainfall);
  };

  var getDaysSinceLastRainfall = function (startTime, lastRainfallDate) {
    if (!lastRainfallDate || !startTime) {
      return null;
    }

    lastRainfallDate = DateTime.parseIsoDate(lastRainfallDate);
    startTime = DateTime.parseIsoDate(startTime);

    return DateTime.getDaysDifferenceNumber(startTime, lastRainfallDate);
  };

  return {
    loadListenersWqMonitoringWorkflow,
    unloadListeners,
    getTabName,
    setToggleInspectConditionFields,
    toggleAssetAccessible,
  };
};

module.exports = RoutineMaintenanceFormGeneral();

const DateTime = require("../dateTime");
const TabbedModal = require("./tabbedModal");
const WqMonitoringConstants = require("../wq/inspection/wqMonitoringConstants");
